import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Divider } from "@/components/Divider";
import { Clock, ArrowRight } from "lucide-react";

export default function Resources() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog")
      .then((r) => setPosts(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white" data-testid="page-resources">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xs uppercase tracking-[0.3em] font-bold text-[#00A651] mb-4">Resources</p>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl text-black tracking-tight">
          Mortgage clarity, in plain English.
        </h1>
        <Divider className="my-6" />
        <p className="font-sub italic text-lg text-gray-600 max-w-2xl">
          Guides, calculators, and explainers — no jargon, no fine print.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-testid="resources-grid">
          {loading ? (
            <p className="text-gray-500">Loading articles…</p>
          ) : (
            posts.map((p) => (
              <Link
                to={`/resources/${p.slug}`}
                key={p.id}
                data-testid={`resource-card-${p.slug}`}
                className="group block bg-white border border-gray-200 hover:border-[#00A651] hover:shadow-md transition-all rounded-sm overflow-hidden"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={p.image_url}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 text-xs text-gray-500 uppercase tracking-wider">
                    <span className="text-[#00A651] font-bold">{p.category}</span>
                    <span className="flex items-center gap-1"><Clock size={12} />{p.read_minutes} min read</span>
                  </div>
                  <h2 className="font-heading font-bold text-lg text-black mt-3 group-hover:text-[#00A651] transition-colors">
                    {p.title}
                  </h2>
                  <p className="font-sub italic text-sm text-gray-600 mt-2 line-clamp-3">{p.excerpt}</p>
                  <p className="mt-4 text-xs uppercase tracking-wider font-bold text-[#F26522] flex items-center gap-1">
                    Read article <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </p>
                </div>
              </Link>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
